import React, { forwardRef } from 'react';
import { styled } from '@mui/material/styles';
import { Select as SelectMUI, type SelectProps as SelectMUIProps } from '@mui/material';

type SelectOption = {
    text: string
    value: string | number
}
export type SelectProps = {
    options: SelectOption[]
} & SelectMUIProps

const SelectMUIStyled = styled(SelectMUI)`
    background: #f9f9fb;
`;

/**
 * we do nothing with ref since we use inputRef for material ui
 * @param param0
 * @param ref
 * @returns
 */
const Select = ({ options, ...selectOpts }: SelectProps, _ref): JSX.Element => <SelectMUIStyled
    native {...selectOpts} variant={selectOpts.variant || 'outlined'}>
    {options.map(opt => <option key={opt.value} value={opt.value}>
        {opt.text}
    </option>)}
</SelectMUIStyled>;

export default forwardRef(Select);
